import styled from 'styled-components';
import { MASKED_TEXT_CLASS } from 'analytics';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Button,
  Card,
  CardContent,
  CardTitle,
  Input,
  RadioGroup,
} from 'components';
import { Checkbox } from '@shadcn/components/ui/checkbox';

export const BlockCard = styled(Card).attrs({
  className: 'gap-4 py-4 outline-none',
})``;

// The shadcn card header reserves a description row; the block only has a title.
export const BlockHeader = styled.div.attrs({
  className: 'px-4',
})``;

export const BlockTitle = styled(CardTitle).attrs({
  className: 'text-sm font-medium leading-4',
})``;

export const BlockContent = styled(CardContent).attrs({
  className: 'px-4',
})``;

export const EntryList = styled(Accordion).attrs({
  className: 'flex flex-col gap-2',
})``;

export const EntryCard = styled.div.attrs({
  className: 'rounded-[10px] border border-border',
})``;

export const EntryItem = styled(AccordionItem).attrs({
  className: 'border-b-0',
})``;

export const EntryTrigger = styled(AccordionTrigger).attrs({
  className: 'items-center px-2 py-1 hover:no-underline [&>svg:last-child]:translate-y-0',
})``;

export const EntryContent = styled(AccordionContent).attrs({
  className: 'pb-0',
})``;

export const EntryHeader = styled.span.attrs({
  className: 'flex flex-1 items-center gap-2 text-left',
})``;

export const EntryIcon = styled.span.attrs({
  className: 'flex h-6 w-6 shrink-0 items-center justify-center rounded-sm bg-success',
})``;

export const EntryIconImage = styled.img.attrs({
  className: 'h-6 w-6 object-contain',
})``;

export const EntryTexts = styled.span.attrs({
  className: 'flex min-w-0 flex-1 flex-col',
})``;

export const EntryTitle = styled.span.attrs({
  className: `text-xs font-semibold leading-4 text-foreground ${MASKED_TEXT_CLASS}`,
})``;

export const EntrySubtitle = styled.span.attrs({
  className: 'text-xs font-semibold leading-4 text-muted-foreground',
})``;

export const EntryState = styled.span.attrs({
  className: 'text-xs font-medium leading-4 text-muted-foreground',
})``;

export const EntryBody = styled.div.attrs({
  className: 'flex flex-col gap-3 px-2 pb-2 pt-1',
})``;

export const Field = styled.div.attrs({
  className: 'flex flex-col gap-1',
})``;

export const GroupField = styled.div.attrs({
  className: 'flex flex-col gap-2',
})``;

export const FieldLabel = styled.label.attrs({
  className: 'text-xs font-semibold leading-4',
})``;

export const BatchInput = styled(Input).attrs({
  className: 'h-8 rounded-lg',
})``;

export const OptionList = styled(RadioGroup).attrs({
  className: 'gap-2',
})``;

export const OptionRow = styled.div.attrs({
  className: 'flex items-center gap-2',
})``;

export const OptionLabel = styled.label.attrs({
  className: `text-sm font-medium leading-none cursor-pointer ${MASKED_TEXT_CLASS}`,
})``;

export const DiagnosisRow = styled.div.attrs({
  className: 'flex items-center gap-2',
})``;

export const DiagnosisCheckbox = styled(Checkbox).attrs({
  className: 'shrink-0 border border-muted-foreground',
})``;

export const DiagnosisCode = styled.span.attrs({
  className: `flex h-7 w-16 items-center justify-center rounded-md border border-input bg-card px-2 text-xs text-card-foreground ${MASKED_TEXT_CLASS}`,
})``;

export const DiagnosisDescription = styled.span.attrs({
  className: `pl-6 text-xs text-card-foreground ${MASKED_TEXT_CLASS}`,
})``;

export const Divider = styled.hr.attrs({
  className: 'border-border',
})``;

export const RemoveRow = styled.div.attrs({
  className: 'flex justify-end',
})``;

export const RemoveButton = styled(Button).attrs({
  variant: 'ghost',
  size: 'xs',
  className: 'bg-destructive/10 text-destructive hover:bg-destructive/15 hover:text-destructive',
})``;
